/* Aza Arcade: Realm Runner. Top-down space rescue on a fixed 720x960 arena with a 60 Hz fixed-step simulation. Local play only. */
(() => {
  'use strict';
  const root = document.querySelector('[data-aza-runner]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const json = (s) => { try { return JSON.parse($(s).textContent); } catch (e) { return null; } };
  const KEEPERS = json('[data-rr-keepers]') || [];
  const CFG = Object.assign({ seconds: 120 }, json('[data-rr-config]'));
  // Shopify's t filter HTML-escapes translations (it's -> it&#39;s); decode before using them as text
  const ta = document.createElement('textarea');
  const unesc = (v) => typeof v === 'string' ? (v.indexOf('&') < 0 ? v : (ta.innerHTML = v, ta.value)) : Array.isArray(v) ? v.map(unesc) : v && typeof v === 'object' ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, unesc(x)])) : v;
  const T = unesc(json('[data-rr-i18n]') || {});
  const W = 720, H = 960, STEP = 1 / 60, MAX_STEPS = 6;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : v; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };
  const fmt = (n) => Math.round(n).toLocaleString();
  const clock = (s) => { s = Math.max(0, Math.ceil(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
  const rand = (a, b) => a + Math.random() * (b - a);

  const RULES = {
    speed: 640, fireEvery: 0.25, bulletSpeed: 1100, hull: 3, invuln: 1, shieldFor: 3, shieldCooldown: 20, topLimit: H * 0.55,
    pts: { drone: 100, asteroid: 50, pod: 250, second: 10, survive: 500, hull: 200 },
    // difficulty bands by elapsed seconds: spawn intervals (s), speed scale, max hazards on screen
    bands: [
      { until: 40, drone: 2.4, asteroid: 1.5, pod: 4.2, speed: 1, max: 7, droneFire: 2.6 },
      { until: 80, drone: 1.7, asteroid: 1.15, pod: 4.6, speed: 1.18, max: 10, droneFire: 2.1 },
      { until: Infinity, drone: 1.2, asteroid: 0.9, pod: 5, speed: 1.35, max: 13, droneFire: 1.7 }
    ]
  };

  const phases = root.querySelectorAll('[data-rr-phase]');
  let phase = 'select';
  const show = (name) => { phase = name; phases.forEach((p) => { p.hidden = p.dataset.rrPhase !== name; }); };
  let keeper = store.get('aza-rr-keeper', KEEPERS[0] && KEEPERS[0].key);
  if (!KEEPERS.some((k) => k.key === keeper)) keeper = KEEPERS[0].key;
  const kd = () => KEEPERS.find((k) => k.key === keeper) || KEEPERS[0];
  let soundOn = store.get('aza-arcade-sound', '1') === '1';

  /* ---------- Sound ---------- */
  let ac = null;
  const tone = (f, d, type, v, when, slide) => {
    if (!soundOn || !ac) return;
    const t = ac.currentTime + (when || 0), o = ac.createOscillator(), g = ac.createGain();
    o.type = type || 'sine'; o.frequency.setValueAtTime(f, t);
    if (slide) o.frequency.exponentialRampToValueAtTime(slide, t + d);
    g.gain.setValueAtTime(v || 0.06, t); g.gain.exponentialRampToValueAtTime(0.0001, t + d);
    o.connect(g).connect(ac.destination); o.start(t); o.stop(t + d);
  };
  const sfx = {
    shot: () => tone(880, 0.05, 'square', 0.012, 0, 440),
    boom: () => tone(180, 0.25, 'sawtooth', 0.05, 0, 40),
    hit: () => { tone(140, 0.35, 'sawtooth', 0.08, 0, 50); },
    pod: () => { tone(660, 0.12, 'sine', 0.07); tone(990, 0.2, 'sine', 0.07, 0.08); },
    shield: () => tone(300, 0.4, 'triangle', 0.06, 0, 900),
    ready: () => { tone(880, 0.12, 'sine', 0.06); tone(1320, 0.16, 'sine', 0.06, 0.1); },
    end: () => { tone(392, 0.3, 'triangle', 0.07); tone(523, 0.5, 'triangle', 0.07, 0.25); }
  };
  const soundBtn = $('[data-rr-sound]');
  const syncSound = () => soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
  soundBtn.addEventListener('click', () => { soundOn = !soundOn; store.set('aza-arcade-sound', soundOn ? '1' : '0'); syncSound(); });
  syncSound();

  /* ---------- Pilot select ---------- */
  const pinfo = $('[data-rr-pinfo]');
  const pick = (k) => {
    keeper = k; store.set('aza-rr-keeper', k);
    root.querySelectorAll('[data-rr-keeper]').forEach((b) => b.setAttribute('aria-checked', b.dataset.rrKeeper === k ? 'true' : 'false'));
    const d = kd();
    pinfo.style.setProperty('--c', d.color);
    pinfo.innerHTML = '';
    const b = document.createElement('b'); b.textContent = d.name + ' · ' + (T.pilot || '');
    const s = document.createElement('span'); s.textContent = d.title + '. ' + (d.powers || []).join(' · ');
    pinfo.append(b, s);
  };
  root.querySelectorAll('[data-rr-keeper]').forEach((b) => b.addEventListener('click', () => pick(b.dataset.rrKeeper)));
  const best = () => parseInt(store.get('aza-rr-best', '0'), 10) || 0;
  const syncBest = () => { const b = best(); $('[data-rr-best-intro]').textContent = b ? (T.best || '') + ': ' + fmt(b) : ''; };

  /* ---------- Canvas and art ---------- */
  const canvas = $('[data-rr-canvas]');
  const ctx = canvas.getContext('2d');
  const stage = $('[data-rr-stage]');
  const bg = new Image(); bg.src = CFG.bg;
  const sym = new Image(); sym.src = CFG.sym;
  let dpr = 1;
  const fit = () => {
    const avail = Math.max(260, window.innerHeight - (window.innerWidth < 900 ? 250 : 210));
    const w = Math.min(stage.parentElement.clientWidth - (window.innerWidth < 900 ? 0 : 238), avail * W / H, W);
    stage.style.width = Math.floor(w) + 'px';
    dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(w * dpr * H / W);
    if (!running) draw(0);
  };
  window.addEventListener('resize', fit);

  /* ---------- State ---------- */
  let s = null, everPaused = false, running = false, paused = false, acc = 0, lastTs = 0, rafId = 0;
  const input = { keys: new Set(), target: null };
  const newState = () => ({
    t: 0, total: CFG.seconds, score: 0, hull: RULES.hull, invuln: 0, shield: 0, cooldown: 0, rescued: 0, kills: 0, secondsScored: 0,
    ship: { x: W / 2, y: H - 140, r: 26 }, fireT: 0,
    bullets: [], enemyShots: [], drones: [], rocks: [], pods: [], parts: [],
    rings: [], debris: [], texts: [], grabs: [], shake: 0, hurt: 0, flash: 0, streak: 0, bandIdx: 0, banner: null, trailT: 0,
    spawn: { drone: 1.2, asteroid: 0.6, pod: 2.5 }, scroll: 0, over: false, won: false,
    stars: Array.from({ length: 110 }, () => ({ x: Math.random() * W, y: Math.random() * H, z: rand(0.25, 1), tw: Math.random() * 6.28 }))
  });
  const band = () => RULES.bands.find((b) => s.t < b.until);
  const hazards = () => s.drones.length + s.rocks.length;
  const rockShape = () => Array.from({ length: 9 }, (_, i) => ({ a: i / 9 * Math.PI * 2, d: rand(0.72, 1.1) }));
  // never spawn on top of the player: the spawn x must be clear of the ship lane when it's near the top
  const spawnX = (pad) => rand(pad, W - pad);

  const spawn = (kind) => {
    const b = band();
    if (kind !== 'pod' && hazards() >= b.max) return;
    if (kind === 'drone') {
      const x = spawnX(70);
      s.drones.push({ x, y: -50, x0: x, r: 30, hp: 1, vy: rand(110, 150) * b.speed, phase: Math.random() * 6.28, amp: rand(20, 70), fire: rand(0.8, b.droneFire) });
    } else if (kind === 'asteroid') {
      const r = rand(30, 46);
      s.rocks.push({ x: spawnX(r + 10), y: -r - 10, r, hp: 2, vy: rand(90, 160) * b.speed, vx: rand(-30, 30), rot: Math.random() * 6.28, vr: rand(-1, 1), shape: rockShape() });
    } else {
      s.pods.push({ x: spawnX(60), y: -40, r: 26, vy: rand(100, 130), bob: Math.random() * 6.28 });
    }
  };
  const burst = (x, y, color, n) => {
    if (reduce) n = Math.min(n, 4);
    for (let i = 0; i < n; i++) {
      const a = Math.random() * 6.28, v = rand(60, 260);
      s.parts.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: rand(0.3, 0.7), max: 0.7, color });
    }
    if (s.parts.length > 220) s.parts.splice(0, s.parts.length - 220);
  };
  // visual-only effects: explosions, debris, floating score text, pods pulled into the ship
  const boom = (x, y, color, size, rock) => {
    burst(x, y, color, rock ? 10 : 16); burst(x, y, '#ffffff', reduce ? 1 : 6);
    s.rings.push({ x, y, r0: size * 0.4, r1: size * 2.6, life: 0.45, max: 0.45, color, w: 6 });
    s.rings.push({ x, y, r0: size * 0.2, r1: size * 1.3, life: 0.16, max: 0.16, color: '#ffffff', fill: true });
    if (rock && !reduce) for (let i = 0; i < 7; i++) {
      const a = Math.random() * 6.28, v = rand(80, 240);
      s.debris.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, rot: Math.random() * 6.28, vr: rand(-8, 8), size: rand(5, 12), life: rand(0.5, 0.9), max: 0.9 });
    }
  };
  const floatTxt = (x, y, txt, color) => s.texts.push({ x, y, txt, color, life: 0.9, max: 0.9 });
  const hit = (a, b, slack) => { const dx = a.x - b.x, dy = a.y - b.y, r = a.r + b.r - (slack || 0); return dx * dx + dy * dy < r * r; };

  const damage = () => {
    if (s.shield > 0 || s.invuln > 0 || s.over) return;
    s.hull--; s.invuln = RULES.invuln; sfx.hit(); burst(s.ship.x, s.ship.y, '#FF2EA6', 16);
    s.shake = 0.4; s.hurt = 0.6; s.rings.push({ x: s.ship.x, y: s.ship.y, r0: 20, r1: 110, life: 0.4, max: 0.4, color: '#FF2EA6', w: 8 });
    if (s.hull <= 0) { s.over = true; s.won = false; }
  };

  /* ---------- Simulation step (fixed 1/60 s) ---------- */
  const step = (dt) => {
    s.t = Math.min(s.total, s.t + dt);
    const whole = Math.floor(s.t);
    if (whole > s.secondsScored) { s.score += (whole - s.secondsScored) * RULES.pts.second; s.secondsScored = whole; }
    if (s.t >= s.total) { s.over = true; s.won = true; s.score += RULES.pts.survive + s.hull * RULES.pts.hull; return; }
    s.scroll = (s.scroll + 40 * dt) % (H * 2);

    // movement: keyboard direction or pointer target, both capped at the same speed
    const sh = s.ship;
    let dx = 0, dy = 0;
    const k = input.keys;
    if (k.has('left')) dx -= 1; if (k.has('right')) dx += 1; if (k.has('up')) dy -= 1; if (k.has('down')) dy += 1;
    if (dx || dy) { const m = Math.hypot(dx, dy); sh.x += dx / m * RULES.speed * dt; sh.y += dy / m * RULES.speed * dt; }
    else if (input.target) {
      const tx = input.target.x - sh.x, ty = input.target.y - sh.y, d = Math.hypot(tx, ty), mv = RULES.speed * dt;
      if (d > 0.5) { const f = Math.min(1, mv / d); sh.x += tx * f; sh.y += ty * f; }
    }
    sh.x = Math.max(sh.r, Math.min(W - sh.r, sh.x));
    sh.y = Math.max(RULES.topLimit, Math.min(H - sh.r - 10, sh.y));

    // timers
    s.invuln = Math.max(0, s.invuln - dt);
    if (s.shield > 0) { s.shield -= dt; if (s.shield <= 0) { s.shield = 0; s.cooldown = RULES.shieldCooldown; } }
    else if (s.cooldown > 0) { s.cooldown -= dt; if (s.cooldown <= 0) { s.cooldown = 0; sfx.ready(); } }

    // auto-fire
    s.fireT -= dt;
    if (s.fireT <= 0) {
      s.fireT += RULES.fireEvery;
      s.bullets.push({ x: sh.x - 10, y: sh.y - 30, r: 5 }, { x: sh.x + 10, y: sh.y - 30, r: 5 });
      s.flash = 0.06; sfx.shot();
    }

    // engine trail, wave banners and effect timers
    s.trailT -= dt;
    if (s.trailT <= 0 && !reduce) {
      s.trailT = 0.025;
      s.parts.push({ x: sh.x + rand(-5, 5), y: sh.y + 28, vx: rand(-25, 25), vy: rand(160, 240), life: 0.32, max: 0.32, color: Math.random() < 0.5 ? '#7FEBFF' : color(), trail: true });
    }
    const bi = RULES.bands.indexOf(band());
    if (bi > s.bandIdx) { s.bandIdx = bi; s.banner = { n: bi + 1, life: 2.4, max: 2.4 }; s.streak = 1.6; }
    s.shake = Math.max(0, s.shake - dt); s.hurt = Math.max(0, s.hurt - dt); s.flash = Math.max(0, s.flash - dt); s.streak = Math.max(0, s.streak - dt);
    if (s.banner && (s.banner.life -= dt) <= 0) s.banner = null;
    s.rings.forEach((g) => { g.life -= dt; }); s.rings = s.rings.filter((g) => g.life > 0);
    s.debris.forEach((d) => { d.x += d.vx * dt; d.y += d.vy * dt; d.rot += d.vr * dt; d.life -= dt; }); s.debris = s.debris.filter((d) => d.life > 0);
    s.texts.forEach((x) => { x.y -= 60 * dt; x.life -= dt; }); s.texts = s.texts.filter((x) => x.life > 0);
    s.grabs.forEach((g) => { g.x += (sh.x - g.x) * Math.min(1, 12 * dt); g.y += (sh.y - g.y) * Math.min(1, 12 * dt); g.life -= dt; }); s.grabs = s.grabs.filter((g) => g.life > 0);
    if (s.parts.length > 260) s.parts.splice(0, s.parts.length - 260);

    // spawning
    const b = band();
    for (const kind of ['drone', 'asteroid', 'pod']) {
      s.spawn[kind] -= dt;
      if (s.spawn[kind] <= 0) { spawn(kind); s.spawn[kind] = b[kind] * rand(0.75, 1.25); }
    }

    // move everything
    s.bullets.forEach((o) => { o.y -= RULES.bulletSpeed * dt; });
    s.enemyShots.forEach((o) => { o.y += o.vy * dt; });
    s.drones.forEach((o) => {
      o.y += o.vy * dt; o.phase += dt * 1.6; o.x = o.x0 + Math.sin(o.phase) * o.amp;
      o.fire -= dt;
      if (o.fire <= 0 && o.y > 40 && o.y < RULES.topLimit) { o.fire = band().droneFire * rand(0.8, 1.3); s.enemyShots.push({ x: o.x, y: o.y + 24, r: 7, vy: 380 }); }
    });
    s.rocks.forEach((o) => { o.y += o.vy * dt; o.x += o.vx * dt; o.rot += o.vr * dt; if (o.x < o.r || o.x > W - o.r) o.vx *= -1; });
    s.pods.forEach((o) => { o.y += o.vy * dt; o.bob += dt * 3; });
    s.parts.forEach((p) => { p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt; });

    // bullets vs hazards (each object scores once; pods are never hit)
    for (const bl of s.bullets) {
      if (bl.dead) continue;
      for (const d of s.drones) {
        if (!d.dead && hit(bl, d)) { bl.dead = true; d.hp--; if (d.hp <= 0) { d.dead = true; s.score += RULES.pts.drone; s.kills++; boom(d.x, d.y, '#FF5A6E', 30); floatTxt(d.x, d.y, '+' + RULES.pts.drone, '#FF8A9A'); sfx.boom(); } break; }
      }
      if (bl.dead) continue;
      for (const r of s.rocks) {
        if (!r.dead && hit(bl, r, 4)) { bl.dead = true; r.hp--; burst(bl.x, bl.y, '#B9A6E8', 3); if (r.hp <= 0) { r.dead = true; s.score += RULES.pts.asteroid; s.kills++; boom(r.x, r.y, '#B9A6E8', r.r, true); floatTxt(r.x, r.y, '+' + RULES.pts.asteroid, '#C9B8FF'); sfx.boom(); } break; }
      }
    }

    // player collisions (forgiving hitbox)
    const hb = { x: sh.x, y: sh.y, r: sh.r * 0.6 };
    for (const p of s.pods) if (!p.dead && hit(hb, p)) { p.dead = true; s.rescued++; s.score += RULES.pts.pod; burst(p.x, p.y, '#00D9FF', 14); s.grabs.push({ x: p.x, y: p.y, life: 0.3, max: 0.3 }); s.rings.push({ x: p.x, y: p.y, r0: 10, r1: 70, life: 0.4, max: 0.4, color: '#00D9FF', w: 5 }); floatTxt(p.x, p.y - 20, '+' + RULES.pts.pod, '#7FEBFF'); sfx.pod(); }
    for (const e of s.enemyShots) if (!e.dead && hit(hb, e)) { e.dead = true; damage(); }
    for (const d of s.drones) if (!d.dead && hit(hb, d, 6)) { if (s.shield <= 0) { d.dead = true; boom(d.x, d.y, '#FF5A6E', 30); } damage(); }
    for (const r of s.rocks) if (!r.dead && hit(hb, r, 8)) { if (s.shield <= 0) { r.dead = true; boom(r.x, r.y, '#B9A6E8', r.r, true); } damage(); }

    // cull
    const on = (o) => !o.dead && o.y > -120 && o.y < H + 80;
    s.bullets = s.bullets.filter(on); s.enemyShots = s.enemyShots.filter(on);
    s.drones = s.drones.filter(on); s.rocks = s.rocks.filter(on); s.pods = s.pods.filter(on);
    s.parts = s.parts.filter((p) => p.life > 0);

  };

  /* ---------- Rendering ---------- */
  const color = () => kd().color;
  const drawShip = (sh, t) => {
    ctx.save(); ctx.translate(sh.x, sh.y);
    const blink = s.invuln > 0 && !reduce && Math.floor(t * 12) % 2;
    ctx.globalAlpha = blink ? 0.4 : 1;
    // engine flame
    const fl = reduce ? 0 : Math.sin(t * 40) * 6 + Math.random() * 4;
    ctx.globalCompositeOperation = 'lighter';
    ctx.fillStyle = color(); ctx.globalAlpha *= 0.55;
    ctx.beginPath(); ctx.moveTo(-12, 20); ctx.lineTo(0, 58 + fl); ctx.lineTo(12, 20); ctx.fill();
    ctx.globalAlpha = blink ? 0.4 : 1;
    ctx.fillStyle = '#7FEBFF';
    ctx.beginPath(); ctx.moveTo(-7, 22); ctx.lineTo(0, 42 + fl); ctx.lineTo(7, 22); ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.beginPath(); ctx.moveTo(-3, 22); ctx.lineTo(0, 32 + fl * 0.5); ctx.lineTo(3, 22); ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
    // hull
    ctx.shadowColor = color(); ctx.shadowBlur = 24;
    ctx.fillStyle = '#E8EAF6';
    ctx.beginPath(); ctx.moveTo(0, -34); ctx.lineTo(10, -8); ctx.lineTo(30, 16); ctx.lineTo(30, 24); ctx.lineTo(8, 18); ctx.lineTo(0, 26); ctx.lineTo(-8, 18); ctx.lineTo(-30, 24); ctx.lineTo(-30, 16); ctx.lineTo(-10, -8); ctx.closePath(); ctx.fill();
    ctx.shadowBlur = 0;
    ctx.fillStyle = color();
    ctx.beginPath(); ctx.moveTo(-30, 16); ctx.lineTo(-12, 10); ctx.lineTo(-10, 18); ctx.lineTo(-30, 24); ctx.fill();
    ctx.beginPath(); ctx.moveTo(30, 16); ctx.lineTo(12, 10); ctx.lineTo(10, 18); ctx.lineTo(30, 24); ctx.fill();
    ctx.fillStyle = '#0A0D1A'; ctx.beginPath(); ctx.ellipse(0, -6, 5, 11, 0, 0, 6.29); ctx.fill();
    ctx.fillStyle = color(); ctx.globalAlpha *= 0.8; ctx.beginPath(); ctx.ellipse(0, -8, 3, 7, 0, 0, 6.29); ctx.fill();
    ctx.restore();
    if (s.shield > 0) {
      ctx.save(); ctx.translate(sh.x, sh.y);
      const pulse = reduce ? 0 : Math.sin(t * 8) * 3;
      ctx.strokeStyle = '#00D9FF'; ctx.lineWidth = 3; ctx.shadowColor = '#00D9FF'; ctx.shadowBlur = 20;
      ctx.globalAlpha = s.shield < 0.8 && !reduce ? 0.5 + 0.5 * Math.sin(t * 30) : 0.95;
      const R = 48 + pulse;
      const g = ctx.createRadialGradient(0, 0, R * 0.4, 0, 0, R);
      g.addColorStop(0, 'rgba(0,217,255,0)'); g.addColorStop(1, 'rgba(0,217,255,0.28)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, R, 0, 6.29); ctx.fill(); ctx.stroke();
      // rotating hex lattice
      ctx.rotate(reduce ? 0 : t * 0.8); ctx.lineWidth = 1.5; ctx.shadowBlur = 0; ctx.globalAlpha *= 0.55;
      ctx.beginPath();
      for (let i = 0; i < 6; i++) { const a = i * Math.PI / 3; ctx.lineTo(Math.cos(a) * R * 0.78, Math.sin(a) * R * 0.78); }
      ctx.closePath();
      for (let i = 0; i < 6; i++) { const a = i * Math.PI / 3; ctx.moveTo(Math.cos(a) * R * 0.78, Math.sin(a) * R * 0.78); ctx.lineTo(Math.cos(a) * R, Math.sin(a) * R); }
      ctx.stroke();
      ctx.restore();
    }
  };
  const drawDrone = (d, t) => {
    ctx.save(); ctx.translate(d.x, d.y);
    if (!reduce) ctx.rotate(-Math.cos(d.phase || 0) * 0.22);
    ctx.shadowColor = '#FF2E5A'; ctx.shadowBlur = 16;
    ctx.fillStyle = '#2A1630'; ctx.strokeStyle = '#FF5A6E'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(0, 22); ctx.lineTo(26, -4); ctx.lineTo(18, -18); ctx.lineTo(6, -8); ctx.lineTo(-6, -8); ctx.lineTo(-18, -18); ctx.lineTo(-26, -4); ctx.closePath(); ctx.fill(); ctx.stroke();
    const pu = reduce ? 1 : 0.75 + 0.25 * Math.sin(t * 9 + (d.phase || 0));
    ctx.shadowBlur = 24 * pu;
    ctx.fillStyle = '#FF2E5A'; ctx.beginPath(); ctx.arc(0, 2, 7 * pu + 1, 0, 6.29); ctx.fill();
    ctx.shadowBlur = 0;
    ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(0, 2, 2.5, 0, 6.29); ctx.fill();
    ctx.fillStyle = Math.floor(t * 4 + (d.phase || 0)) % 2 ? '#FF5A6E' : '#5A1A2A';
    ctx.fillRect(-22, -6, 4, 4); ctx.fillRect(18, -6, 4, 4);
    ctx.restore();
  };
  const drawRock = (r) => {
    ctx.save(); ctx.translate(r.x, r.y); ctx.rotate(r.rot);
    const rg = ctx.createRadialGradient(-r.r * 0.35, -r.r * 0.35, r.r * 0.1, 0, 0, r.r * 1.1);
    rg.addColorStop(0, r.hp < 2 ? '#7A5FA0' : '#6A5590'); rg.addColorStop(0.55, r.hp < 2 ? '#4A3A66' : '#3A2F55'); rg.addColorStop(1, '#17122A');
    ctx.fillStyle = rg; ctx.strokeStyle = '#8B5CF6'; ctx.lineWidth = 2; ctx.shadowColor = '#8B5CF6'; ctx.shadowBlur = 10;
    ctx.beginPath();
    r.shape.forEach((p, i) => { const x = Math.cos(p.a) * r.r * p.d, y = Math.sin(p.a) * r.r * p.d; i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); });
    ctx.closePath(); ctx.fill(); ctx.stroke(); ctx.shadowBlur = 0;
    ctx.fillStyle = '#1E1838'; ctx.beginPath(); ctx.arc(r.r * 0.25, -r.r * 0.2, r.r * 0.22, 0, 6.29); ctx.arc(-r.r * 0.3, r.r * 0.3, r.r * 0.14, 0, 6.29); ctx.fill();
    if (r.hp < 2) { ctx.strokeStyle = '#FF2EA6'; ctx.beginPath(); ctx.moveTo(-r.r * 0.5, -r.r * 0.1); ctx.lineTo(0, r.r * 0.1); ctx.lineTo(r.r * 0.3, r.r * 0.5); ctx.stroke(); }
    ctx.restore();
  };
  const drawPod = (p, t) => {
    ctx.save(); ctx.translate(p.x, p.y + (reduce ? 0 : Math.sin(p.bob) * 4));
    if (!reduce) {
      const ph = (t * 0.9 + (p.bob || 0) * 0.1) % 1;
      ctx.strokeStyle = '#00D9FF'; ctx.lineWidth = 2; ctx.globalAlpha = (1 - ph) * 0.7;
      ctx.beginPath(); ctx.arc(0, 0, 28 + ph * 34, 0, 6.29); ctx.stroke();
      ctx.globalAlpha = 1;
    }
    ctx.shadowColor = '#00D9FF'; ctx.shadowBlur = 22;
    ctx.fillStyle = '#DDE6FF';
    ctx.beginPath(); ctx.roundRect ? ctx.roundRect(-18, -26, 36, 52, 16) : ctx.rect(-18, -26, 36, 52); ctx.fill();
    ctx.shadowBlur = 0;
    ctx.fillStyle = '#0E1A3A'; ctx.beginPath(); ctx.roundRect ? ctx.roundRect(-11, -16, 22, 32, 9) : ctx.rect(-11, -16, 22, 32); ctx.fill();
    if (sym.complete && sym.naturalWidth) ctx.drawImage(sym, -6, -13, 12, 26);
    ctx.fillStyle = '#00D9FF'; ctx.globalAlpha = 0.6 + 0.4 * Math.sin(t * 6);
    ctx.fillRect(-14, 24, 28, 4);
    ctx.restore();
  };
  const draw = (t) => {
    const k = canvas.width / W;
    const sk = s && s.shake > 0 && !reduce ? s.shake * 30 : 0;
    ctx.setTransform(k, 0, 0, k, (Math.random() - 0.5) * sk * k, (Math.random() - 0.5) * sk * k);
    ctx.fillStyle = '#0A0D1A'; ctx.fillRect(0, 0, W, H);
    const st = s || newState();
    if (bg.complete && bg.naturalWidth) {
      // alternate normal and mirrored copies so the scrolling image has no seam (pattern repeats every 2H)
      const bh = H, bw = bg.naturalWidth * bh / bg.naturalHeight, bx = (W - bw) / 2, y = reduce ? 0 : st.scroll;
      ctx.globalAlpha = 0.75;
      for (const off of [-2, -1, 0, 1]) {
        const top = y + off * bh;
        if (top > H || top + bh < 0) continue;
        if (off % 2 === 0) ctx.drawImage(bg, bx, top, bw, bh);
        else { ctx.save(); ctx.translate(0, top + bh); ctx.scale(1, -1); ctx.drawImage(bg, bx, 0, bw, bh); ctx.restore(); }
      }
      ctx.globalAlpha = 1;
    }
    ctx.fillStyle = '#ffffff'; ctx.strokeStyle = '#ffffff';
    const streak = s ? s.streak : 0;
    st.stars.forEach((p) => {
      const y = (p.y + (reduce ? 0 : st.scroll * 4 * p.z * p.z)) % H;
      ctx.globalAlpha = p.z * (0.55 + 0.35 * Math.sin(t * 3 + p.tw));
      if (streak > 0 && p.z > 0.5 && !reduce) { ctx.lineWidth = 2 * p.z; ctx.beginPath(); ctx.moveTo(p.x, y); ctx.lineTo(p.x, y - 60 * p.z * Math.min(1, streak)); ctx.stroke(); }
      else ctx.fillRect(p.x, y, 2.2 * p.z, 2.2 * p.z);
    });
    ctx.globalAlpha = 1;
    if (!s) return;
    // safe zone line
    ctx.strokeStyle = '#00D9FF22'; ctx.setLineDash([8, 10]); ctx.beginPath(); ctx.moveTo(0, RULES.topLimit - 30); ctx.lineTo(W, RULES.topLimit - 30); ctx.stroke(); ctx.setLineDash([]);
    s.pods.forEach((p) => drawPod(p, t));
    s.rocks.forEach(drawRock);
    s.drones.forEach((d) => drawDrone(d, t));
    ctx.globalCompositeOperation = 'lighter';
    s.parts.forEach((p) => {
      const a = Math.max(0, p.life / p.max); ctx.globalAlpha = a; ctx.fillStyle = p.color;
      const r = p.trail ? 5 * a + 1 : 2.5 + 1.5 * a; ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, 6.29); ctx.fill();
    });
    ctx.globalAlpha = 1;
    ctx.lineCap = 'round'; ctx.shadowColor = '#00D9FF'; ctx.shadowBlur = 12;
    s.bullets.forEach((b) => {
      const g = ctx.createLinearGradient(b.x, b.y + 22, b.x, b.y - 12); g.addColorStop(0, '#00D9FF00'); g.addColorStop(1, '#E8FBFF');
      ctx.strokeStyle = g; ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(b.x, b.y + 22); ctx.lineTo(b.x, b.y - 12); ctx.stroke();
    });
    if (s.flash > 0) { ctx.fillStyle = '#BFF6FF'; ctx.globalAlpha = s.flash / 0.06; [-10, 10].forEach((o) => { ctx.beginPath(); ctx.arc(s.ship.x + o, s.ship.y - 32, 9, 0, 6.29); ctx.fill(); }); ctx.globalAlpha = 1; }
    ctx.fillStyle = '#FF2EA6'; ctx.shadowColor = '#FF2EA6'; ctx.shadowBlur = 14;
    s.enemyShots.forEach((e) => { ctx.beginPath(); ctx.ellipse(e.x, e.y, 5, 12, 0, 0, 6.29); ctx.fill(); ctx.fillStyle = '#FFD0EC'; ctx.beginPath(); ctx.ellipse(e.x, e.y + 2, 2, 6, 0, 0, 6.29); ctx.fill(); ctx.fillStyle = '#FF2EA6'; });
    ctx.shadowBlur = 0;
    s.rings.forEach((g) => {
      const k = 1 - g.life / g.max, r = g.r0 + (g.r1 - g.r0) * (1 - Math.pow(1 - k, 3));
      ctx.globalAlpha = 1 - k;
      if (g.fill) { ctx.fillStyle = g.color; ctx.beginPath(); ctx.arc(g.x, g.y, r, 0, 6.29); ctx.fill(); }
      else { ctx.strokeStyle = g.color; ctx.lineWidth = g.w * (1 - k) + 1; ctx.beginPath(); ctx.arc(g.x, g.y, r, 0, 6.29); ctx.stroke(); }
    });
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    s.debris.forEach((d) => {
      ctx.save(); ctx.translate(d.x, d.y); ctx.rotate(d.rot); ctx.globalAlpha = Math.max(0, d.life / d.max);
      ctx.fillStyle = '#5A4A80'; ctx.strokeStyle = '#B9A6E8'; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.moveTo(-d.size, -d.size * 0.4); ctx.lineTo(d.size * 0.6, -d.size * 0.7); ctx.lineTo(d.size * 0.8, d.size * 0.6); ctx.lineTo(-d.size * 0.5, d.size * 0.5); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.restore();
    });
    s.grabs.forEach((g) => { ctx.globalAlpha = g.life / g.max; ctx.fillStyle = '#DDE6FF'; ctx.shadowColor = '#00D9FF'; ctx.shadowBlur = 20; ctx.beginPath(); ctx.arc(g.x, g.y, 14 * g.life / g.max + 3, 0, 6.29); ctx.fill(); ctx.shadowBlur = 0; });
    ctx.globalAlpha = 1;
    drawShip(s.ship, t);
    ctx.textAlign = 'center'; ctx.font = '700 30px Rajdhani, sans-serif';
    s.texts.forEach((x) => { ctx.globalAlpha = Math.min(1, x.life / x.max * 1.6); ctx.fillStyle = x.color; ctx.shadowColor = x.color; ctx.shadowBlur = 12; ctx.fillText(x.txt, x.x, x.y); });
    ctx.shadowBlur = 0; ctx.globalAlpha = 1;
    if (s.hurt > 0) {
      const g = ctx.createRadialGradient(W / 2, H / 2, H * 0.3, W / 2, H / 2, H * 0.75);
      g.addColorStop(0, '#FF2E5A00'); g.addColorStop(1, '#FF2E5A'); ctx.globalAlpha = Math.min(0.7, s.hurt); ctx.fillStyle = g; ctx.fillRect(-20, -20, W + 40, H + 40); ctx.globalAlpha = 1;
    }
    if (s.banner) {
      const b = s.banner, k = 1 - b.life / b.max, a = k < 0.15 ? k / 0.15 : k > 0.8 ? (1 - k) / 0.2 : 1;
      ctx.globalAlpha = a;
      const g = ctx.createLinearGradient(0, 0, W, 0); g.addColorStop(0, '#00D9FF00'); g.addColorStop(0.5, '#0A0D1Ae6'); g.addColorStop(1, '#00D9FF00');
      ctx.fillStyle = g; ctx.fillRect(0, H * 0.3 - 56, W, 112);
      ctx.fillStyle = '#00D9FF'; ctx.fillRect(W * 0.2, H * 0.3 - 56, W * 0.6, 2); ctx.fillRect(W * 0.2, H * 0.3 + 54, W * 0.6, 2);
      ctx.font = '700 60px Rajdhani, sans-serif'; ctx.fillStyle = '#ffffff'; ctx.shadowColor = '#FF2EA6'; ctx.shadowBlur = 20;
      ctx.fillText(((T.wave || 'Wave __N__').replace('__N__', b.n)).toUpperCase(), W / 2 + (1 - a) * 40, H * 0.3 + 6);
      ctx.shadowBlur = 0; ctx.font = '600 22px Rajdhani, sans-serif'; ctx.fillStyle = '#7FEBFF';
      ctx.fillText(((T.wave_t || [])[b.n - 2] || '').toUpperCase(), W / 2, H * 0.3 + 40);
      ctx.globalAlpha = 1;
    }
    ctx.textAlign = 'start';
  };

  /* ---------- HUD ---------- */
  const el = { score: $('[data-rr-score]'), time: $('[data-rr-time]'), rescued: $('[data-rr-rescued]'), hull: root.querySelectorAll('[data-rr-hull] i'), meter: $('[data-rr-meter]'), btn: $('[data-rr-shield]'), label: $('[data-rr-shield-label]') };
  let hudCache = '';
  const hud = () => {
    const left = s.total - s.t;
    const key = [Math.round(s.score), Math.ceil(left), s.rescued, s.hull, Math.ceil(s.shield * 10), Math.ceil(s.cooldown)].join('|');
    if (key === hudCache) return;
    hudCache = key;
    el.score.textContent = fmt(s.score);
    el.time.textContent = clock(left);
    el.time.parentElement.classList.toggle('z-low', left <= 10);
    el.rescued.textContent = s.rescued;
    el.hull.forEach((h, i) => h.classList.toggle('z-off', i >= s.hull));
    if (s.shield > 0) { el.meter.style.width = (s.shield / RULES.shieldFor * 100) + '%'; el.label.textContent = T.shield_on || ''; el.btn.disabled = true; }
    else if (s.cooldown > 0) { el.meter.style.width = ((1 - s.cooldown / RULES.shieldCooldown) * 100) + '%'; el.label.textContent = (T.shield || '') + ' ' + Math.ceil(s.cooldown) + 's'; el.btn.disabled = true; }
    else { el.meter.style.width = '100%'; el.label.textContent = T.shield_ready || ''; el.btn.disabled = false; }
  };

  /* ---------- Loop ---------- */
  const frame = (ts) => {
    if (!running) return;
    rafId = requestAnimationFrame(frame);
    const dt = lastTs ? Math.min(0.25, (ts - lastTs) / 1000) : 0;
    lastTs = ts;
    if (!paused) {
      acc += dt;
      let n = 0;
      while (acc >= STEP && n < MAX_STEPS && !s.over) { step(STEP); acc -= STEP; n++; }
      if (n === MAX_STEPS) acc = 0; // device stalled: drop the backlog instead of fast-forwarding hazards through the ship
      hud();
      if (s.over) { draw(ts / 1000); finish(); return; }
    }
    draw(ts / 1000);
  };

  /* ---------- Input ---------- */
  const toArena = (e) => {
    const r = canvas.getBoundingClientRect();
    const touch = e.pointerType === 'touch';
    return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * H - (touch ? 110 : 0) };
  };
  canvas.addEventListener('pointerdown', (e) => {
    if (!running || paused) return;
    e.preventDefault();
    try { canvas.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    input.pointer = e.pointerId; input.target = toArena(e);
  });
  canvas.addEventListener('pointermove', (e) => { if (input.pointer === e.pointerId) input.target = toArena(e); else if (e.pointerType === 'mouse' && running && !paused && e.buttons) input.target = toArena(e); });
  const release = (e) => { if (input.pointer === e.pointerId) { input.pointer = null; input.target = null; } };
  canvas.addEventListener('pointerup', release);
  canvas.addEventListener('pointercancel', release);
  const raiseShield = () => {
    if (!running || paused || !s || s.shield > 0 || s.cooldown > 0) return;
    s.shield = RULES.shieldFor; sfx.shield(); hud();
    s.rings.push({ x: s.ship.x, y: s.ship.y, r0: 30, r1: 140, life: 0.5, max: 0.5, color: '#00D9FF', w: 4 });
  };
  el.btn.addEventListener('click', raiseShield);
  const KEYMAP = { ArrowLeft: 'left', a: 'left', A: 'left', ArrowRight: 'right', d: 'right', D: 'right', ArrowUp: 'up', w: 'up', W: 'up', ArrowDown: 'down', s: 'down', S: 'down' };
  document.addEventListener('keydown', (e) => {
    if (phase !== 'play' || !running) return;
    if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
    if (e.key === 'p' || e.key === 'P' || e.key === 'Escape') { e.preventDefault(); pause(!paused); return; }
    if (paused) return;
    if (KEYMAP[e.key]) { e.preventDefault(); input.keys.add(KEYMAP[e.key]); return; }
    if (e.key === ' ') { e.preventDefault(); raiseShield(); }
  });
  document.addEventListener('keyup', (e) => { if (KEYMAP[e.key]) input.keys.delete(KEYMAP[e.key]); });
  window.addEventListener('blur', () => input.keys.clear());

  /* ---------- Keeper cut-in ---------- */
  const cutEl = $('[data-cutin]');
  let cutTimer = 0;
  const cutin = (d, title) => {
    if (!cutEl) return;
    cutEl.style.setProperty('--c', d.color);
    cutEl.querySelector('[data-cutin-img]').src = d.img.replace(/aza-keeper-([a-z]+)\.webp/, 'aza-keeper-$1-crop.webp');
    cutEl.querySelector('[data-cutin-k]').textContent = d.name;
    cutEl.querySelector('[data-cutin-pw]').textContent = title;
    cutEl.hidden = false; cutEl.classList.remove('z-on'); void cutEl.offsetWidth; cutEl.classList.add('z-on');
    clearTimeout(cutTimer); cutTimer = setTimeout(() => { cutEl.hidden = true; }, reduce ? 700 : 1100);
  };

  /* ---------- Flow ---------- */
  const pausedEl = $('[data-rr-paused]');
  const pause = (on) => {
    if (!running) return;
    paused = on; pausedEl.hidden = !on; input.keys.clear();
    if (on) everPaused = true;
    input.target = null; input.pointer = null;
    if (on) $('[data-rr-resume]').focus(); else { lastTs = 0; canvas.focus({ preventScroll: true }); }
  };
  const countEl = $('[data-rr-count]'), countN = $('[data-rr-count-n]');
  const start = () => {
    if (!ac) { try { ac = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ac = null; } }
    if (ac && ac.state === 'suspended') ac.resume();
    const d = kd();
    $('[data-rr-side]').style.setProperty('--c', d.color);
    $('[data-rr-side-img]').src = d.img.replace(/aza-keeper-([a-z]+)\.webp/, 'aza-keeper-$1-crop.webp');
    $('[data-rr-side-name]').textContent = d.name;
    s = newState(); acc = 0; lastTs = 0; paused = false; everPaused = false; hudCache = ''; input.keys.clear(); input.target = null;
    show('play'); fit(); hud(); draw(0);
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    let n = 3;
    countEl.hidden = false; countN.textContent = n; tone(660, 0.1, 'square', 0.04);
    const tickDown = () => {
      n--;
      if (n > 0) { countN.textContent = n; tone(660, 0.1, 'square', 0.04); setTimeout(tickDown, 600); return; }
      countEl.hidden = true; tone(990, 0.16, 'square', 0.05);
      cutin(d, T.launch || '');
      running = true; canvas.focus({ preventScroll: true });
      if (window.AzaBoard) window.AzaBoard.start('realm-runner');
      rafId = requestAnimationFrame(frame);
    };
    setTimeout(tickDown, reduce ? 250 : 600);
  };
  const finish = () => {
    running = false; cancelAnimationFrame(rafId); pausedEl.hidden = true; sfx.end();
    if (cutEl) { clearTimeout(cutTimer); cutEl.hidden = true; }
    const prev = best(), isBest = s.score > prev;
    if (isBest) store.set('aza-rr-best', String(s.score));
    const d = kd();
    $('[data-rr-res-h]').textContent = s.won ? (T.won_h || '') : (T.lost_h || '');
    $('[data-rr-res-t]').textContent = s.won ? (T.won_t || '') : (T.lost_t || '');
    $('[data-rr-res-sym]').classList.toggle('z-on', s.won);
    $('[data-rr-res-score]').textContent = fmt(s.score);
    $('[data-rr-res-best]').textContent = fmt(Math.max(prev, s.score));
    $('[data-rr-res-rescued]').textContent = s.rescued;
    $('[data-rr-res-kills]').textContent = s.kills;
    const nb = $('[data-rr-res-new]'); nb.hidden = !(isBest && s.score > 0); nb.textContent = T.new_best || '';
    const meet = $('[data-rr-meet]');
    meet.textContent = (T.meet || '').replace('__NAME__', d.name) + ' →'; meet.href = d.url; meet.style.color = d.color;
    if (window.AzaBoard) window.AzaBoard.finish({ game: 'realm-runner', score: s.score, keeper, ranked: !everPaused });
    setTimeout(() => { show('results'); $('[data-rr-again]').focus({ preventScroll: true }); }, reduce ? 0 : 700);
  };

  $('[data-rr-start]').addEventListener('click', start);
  $('[data-rr-again]').addEventListener('click', start);
  $('[data-rr-change]').addEventListener('click', () => { syncBest(); show('select'); });
  $('[data-rr-pause]').addEventListener('click', () => pause(true));
  $('[data-rr-resume]').addEventListener('click', () => pause(false));
  $('[data-rr-quit]').addEventListener('click', () => { if (running) { s.over = true; s.won = false; finish(); } });
  document.addEventListener('visibilitychange', () => { if (document.hidden && running && !paused) pause(true); });

  pick(keeper);
  syncBest();
})();
